export default __webpack_public_path__ + "static/media/digital_logo.0a505cad.svg";